import React from 'react';
import styles from './DataGrid.module.css';
import { SortDirection } from './types';

interface SortIconProps {
  direction?: SortDirection;
  active: boolean;
}

export function SortIcon({ direction, active }: SortIconProps) {
  return (
    <span className={styles.sortIcon} aria-hidden="true">
      <svg width="10" height="12" viewBox="0 0 10 12" fill="none">
        <path
          d="M5 1L5 11M5 1L2 4M5 1L8 4"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={active && direction === 'asc' ? 1 : 0.35}
        />
        <path
          d="M5 11L5 1M5 11L2 8M5 11L8 8"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={active && direction === 'desc' ? 1 : 0.35}
        />
      </svg>
    </span>
  );
}
